import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "header md:!tw-right-[-13px]" }
const _hoisted_2 = { class: "md:!tw-flex md:!tw-flex-col md:!tw-gap-[.5rem]" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "md:!tw-mb-0 md:!tw-text-[24px]" }, "Why iknowa?", -1)
const _hoisted_4 = { class: "carousel__img !tw-mb-0 tw-relative !tw-w-full tw-overflow-hidden md:!tw-min-h-[200px] rmd:!tw-h-[400px] rmd:!tw-m-0 rmd:!tw-pt-8 rmd:! rmd:!tw-mb-4" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "property_owner_benefits_modal_title md:!tw-mb-0 md:!tw-text-[18px]" }
const _hoisted_8 = { class: "property_owner_benefits_modal_text md:!tw-mb-0 md:!tw-min-h-[unset]" }
const _hoisted_9 = { class: "carousel-controls" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    width: "912px",
    "max-width": "100%",
    height: "auto",
    class: "property_owner_benefits_modal"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          icon: "mdi-close",
          onClick: $setup.onClickCloseButton
        }, null, 8, ["onClick"])
      ]),
      _createVNode(_component_v_carousel, {
        height: "auto",
        class: "md:!tw-h-auto",
        style: {"overflow":"initial"},
        "hide-delimiter-background": "",
        "show-arrows": false,
        continuous: false,
        modelValue: $setup.model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.model) = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.items, (item, i) => {
            return (_openBlock(), _createBlock(_component_v_carousel_item, { key: i }, {
              default: _withCtx(() => [
                _createVNode(_component_v_sheet, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _hoisted_3,
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("img", {
                          width: "90",
                          class: "tw-relative tw-z-10 !tw-object-contain",
                          src: item.src
                        }, null, 8, _hoisted_5),
                        _createElementVNode("img", {
                          class: "tw-w-full !tw-h-auto tw-absolute tw-z-0 tw-top-[-16px] tw-right-0 tw-object-contain rmd:!tw-top-[-27px]",
                          src: require('@/assets/images/bg-property-1.png')
                        }, null, 8, _hoisted_6)
                      ]),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item?.title), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(item?.description), 1)
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_v_btn, {
          variant: "elevated",
          class: "button button-orange",
          onClick: $setup.prevSlide,
          disabled: $setup.model === 0
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Previous ")
          ]),
          _: 1
        }, 8, ["onClick", "disabled"]),
        _createVNode(_component_v_btn, {
          variant: "elevated",
          class: "button button-orange",
          onClick: $setup.handleNextClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.model === $setup.items.length - 1
              ? $setup.activeUserWorkstation.name === "Default"
                ? "Go to Control Center"
                : "Go to Dashboard"
              : "Next"), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}